<!-- Improved Classes List Component Template - Bootstrap 5.3.7 -->
<div class="classes-container">
  
  <!-- Spacer for layout -->
  <div style="height: 2rem;"></div>
  
  <div class="container">
    
    <!-- Header Section Card -->
    <div class="row mb-4">
      <div class="col-12">
        <div class="card border-0 shadow-sm classes-header-card">
          <div class="card-body text-center py-4">
            <!-- <div class="classes-header-card__icon mb-3">
              🎓
            </div> -->
            <h1 class="classes-header__title card-title mb-3">
              {{ 'CLASSES.TITLE' | translate }}
            </h1>
            <p class="classes-header__subtitle card-text text-muted mb-0">
              {{ 'CLASSES.WELCOME_MESSAGE' | translate }}
            </p>
          </div>
        </div>
      </div>
    </div>

    <!-- Instructions Section Card -->
    <div class="row mb-5">
      <div class="col-12">
        <div class="card border-0 shadow classes-instructions-card">
          <div class="card-header primary-dark-bg text-white border-0">
            <div class="d-flex align-items-center justify-content-between">
              <div class="d-flex align-items-center">
                <!-- <div class="classes-instructions-card__icon me-3">
                  📋
                </div> -->
                <h2 class="card-title mb-0 h4">
                    {{ 'CLASSES.GETTING_STARTED_GUIDE' | translate }}
                </h2>
              </div>
              <button 
                class="btn btn-outline-light btn-sm"
                type="button"
                (click)="toggleInstructions()"
                [attr.aria-expanded]="isInstructionsExpanded"
                [attr.aria-controls]="'instructionsCollapse'">
                <i class="fa" [class.fa-chevron-up]="isInstructionsExpanded" [class.fa-chevron-down]="!isInstructionsExpanded"></i>
                <!-- <span class="ms-2">{{ isInstructionsExpanded ? ('CLASSES.COLLAPSE' | translate) : ('CLASSES.EXPAND' | translate) }}</span> -->
              </button>
            </div>
          </div>
          <div 
            id="instructionsCollapse"
            class="collapse show"
            [class.show]="isInstructionsExpanded">
            <div class="card-body p-4">
              
              <div class="row g-4">
              
              <!-- Left Column - Instructions -->
              <div class="col-12 col-lg-6">
                
                <div class="classes-instructions__section">
                  <h3 class="classes-instructions__title h5 primary-dark mb-3">
                    {{ 'CLASSES.INSTRUCTIONS_TITLE' | translate }}
                  </h3>
                  
                  <div class="alert alert-info border-0 mb-4">
                    <div class="d-flex align-items-start">
                      <div class="me-2">ℹ️</div>
                      <p class="classes-instructions__text classes-instructions__text--italic mb-0">
                        {{ 'CLASSES.ORDER_NOTE' | translate }}
                      </p>
                    </div>
                  </div>

                  <ol class="classes-instructions__list list-group list-group-flush">
                    <li class="classes-instructions__list-item list-group-item border-0 px-0">
                      <div class="d-flex align-items-start">
                        <span class="badge bg-primary rounded-pill me-3 mt-1">1</span>
                        <strong>{{ 'CLASSES.STEP_1' | translate }}</strong>
                      </div>
                    </li>
                    <li class="classes-instructions__list-item list-group-item border-0 px-0">
                      <div class="d-flex align-items-start">
                        <span class="badge bg-primary rounded-pill me-3 mt-1">2</span>
                        <strong>{{ 'CLASSES.STEP_2' | translate }}</strong>
                      </div>
                    </li>
                    <li class="classes-instructions__list-item list-group-item border-0 px-0">
                      <div class="d-flex align-items-start">
                        <span class="badge bg-primary rounded-pill me-3 mt-1">3</span>
                        <strong>{{ 'CLASSES.STEP_3' | translate }}</strong>
                      </div>
                    </li>
                  </ol>
                </div>

                <div class="classes-instructions__section mt-4">
                  <h4 class="classes-instructions__subtitle h6 text-secondary mb-3">
                    📖 {{ 'CLASSES.ADDITIONAL_RESOURCES' | translate }}
                  </h4>
                  <div class="list-group list-group-flush">
                    <!--
                      <a
                        href="https://online.fliphtml5.com/qubm/xuvw/#p=1"
                        target="_blank"
                        rel="noopener noreferrer"
                        class="list-group-item list-group-item-action border-0 px-0 classes-instructions__link"
                        [attr.aria-label]="'CLASSES.EBOOK_LINK' | translate">
                        <div class="d-flex align-items-center">
                          <span class="me-2">📚</span>
                          {{ 'CLASSES.EBOOK_LINK' | translate }}
                          <span class="ms-auto">
                            <i class="fa fa-external-link text-muted small"></i>
                          </span>
                        </div>
                      </a>
                    -->
                    <a href="{{ classFAQ }}"
                       target="_blank"
                       rel="noopener noreferrer"
                       class="list-group-item list-group-item-action border-0 px-0 classes-instructions__link"
                       [attr.aria-label]="'CLASSES.FAQ_LINK' | translate">
                      <div class="d-flex align-items-center">
                        <span class="me-2">❓</span>
                        {{ 'CLASSES.FAQ_LINK' | translate }}
                        <span class="ms-auto">
                          <i class="fa fa-external-link text-muted small m-2"></i>
                        </span>
                      </div>
                    </a>
                  </div>
                </div>
                
              </div>

              <!-- Right Column - What's Included -->
              <div class="col-12 col-lg-6">
                
                <div class="classes-instructions__section">
                  <h3 class="classes-instructions__subtitle h5 text-success mb-3">
                    ✨ {{ 'CLASSES.INCLUDED_TITLE' | translate }}
                  </h3>
                  
                  <div class="card bg-light border-0">
                    <div class="card-body">
                      <ul class="classes-instructions__list list-unstyled mb-0">
                        <li class="classes-instructions__list-item d-flex align-items-center mb-3">
                          <div class="rounded-circle bg-success text-white d-flex align-items-center justify-content-center me-3" style="width: 2.5rem; height: 2.5rem; font-size: 1.2rem;">
                            📹
                          </div>
                          <span>{{ 'CLASSES.INCLUDED_TEACHING' | translate }}</span>
                        </li>
                        <li class="classes-instructions__list-item d-flex align-items-center mb-3">
                          <div class="rounded-circle bg-info text-white d-flex align-items-center justify-content-center me-3" style="width: 2.5rem; height: 2.5rem; font-size: 1.2rem;">
                            📚
                          </div>
                          <span>{{ 'CLASSES.INCLUDED_CHAPTER' | translate }}</span>
                        </li>
                        <li class="classes-instructions__list-item d-flex align-items-center">
                          <div class="rounded-circle bg-warning text-white d-flex align-items-center justify-content-center me-3" style="width: 2.5rem; height: 2.5rem; font-size: 1.2rem;">
                            🧠
                          </div>
                          <span>{{ 'CLASSES.INCLUDED_QUIZZES' | translate }}</span>
                        </li>
                      </ul>
                    </div>
                  </div>
                  
                  <div class="alert alert-success border-0 mt-4">
                    <div class="d-flex align-items-start">
                      <div class="me-2">💡</div>
                      <p class="classes-instructions__text classes-instructions__text--italic mb-0">
                        {{ 'CLASSES.COMPLETION_NOTE' | translate }}
                      </p>
                    </div>
                  </div>
                </div>
                
              </div>
              
              </div>
              
              <!-- Scroll to Classes Button -->
              <div class="row mt-4">
                <div class="col-12 text-center">
                  <button 
                    class="btn btn-primary btn-lg"
                    (click)="scrollToClasses()"
                    type="button">
                    <i class="fa fa-arrow-down me-2"></i>
                    {{ 'CLASSES.START_CLASSES' | translate }}
                  </button>
                  <!-- <p class="text-muted small mt-2 mb-0">
                    {{ 'CLASSES.SCROLL_TO_CLASSES_HINT' | translate }}
                  </p> -->
                </div>
              </div>
              
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Classes Grid Section -->
    <main id="classesGrid" class="classes-grid">
      
      <!-- Loading State -->
      <div 
        *ngIf="!userClassesList || !userClassesTakenList"
        class="row">
        <div class="col-12">
          <div class="text-center p-5">
            <div class="display-1 mb-3">⏳</div>
            <p class="text-muted">{{ 'CLASSES.LOADING_CLASSES' | translate }}...</p>
          </div>
        </div>
      </div>

      <!-- Empty State -->
      <div 
        *ngIf="userClassesList && userClassesList.length === 0" 
        class="row">
        <div class="col-12">
          <div class="text-center p-5">
            <div class="display-1 mb-3">📚</div>
            <p class="text-muted">{{ 'CLASSES.NO_CLASSES_AVAILABLE' | translate }}</p>
          </div>
        </div>
      </div>

      <!-- Class Cards Grid -->
      <div 
        *ngIf="userClassesList && userClassesTakenList && userClassesList.length > 0"
        class="row row-cols-1 row-cols-md-2 row-cols-xl-3 row-cols-xxl-4 g-4">
        
        <!-- Individual Class Card -->
        <div 
          *ngFor="let userClass of userClassesList; trackBy: trackByClassId"
          class="col">
          <div *ngIf="userClassesTakenList[userClass.id * 1 - 1] as userClassesTaken">
            <app-class-card
              [userClass]="userClass"
              [userClassesTaken]="userClassesTaken"
              [userClassesTakenList]="userClassesTakenList">
            </app-class-card>
          </div>
        </div>
        
      </div>
      
    </main>
    
  </div>
  
</div>
